<template>
  <div style="height:100%">
    <div class="result-main">
      <div class="result-item">
        <span class="result-item-left">姓&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;名</span>
        <span class="result-item-right">{{resultData.data[0].userName}}</span>
      </div>
      <div class="result-item">
        <span class="result-item-left">编&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;号</span>
        <span class="result-item-right">{{resultData.data[0].certNo}}</span>
      </div>
      <div class="result-item" v-if="resultData.data[0].phoneNo !==''">
        <span class="result-item-left">电话号码</span>
        <span class="result-item-right">{{resultData.data[0].phoneNo}}</span>
      </div>
      <div class="result-item">
        <span class="result-item-left">类&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;型</span>
        <span class="result-item-right">{{resultData.data[0].projectName}}</span>
      </div>
      <div class="result-item">
        <span class="result-item-left">证书名称</span>
        <span class="result-item-right">{{resultData.data[0].certName}}</span>
      </div>
      <div class="result-item">
        <span class="result-item-left">发证日期 </span>
        <span class="result-item-right">{{formatDate(resultData.data[0].issueTime)}}</span>
      </div>
      <div class="result-item" v-if="resultData.data[0].idNo !==''">
        <span class="result-item-left">身份证号</span>
        <span class="result-item-right">{{resultData.data[0].idNo}}</span>
      </div>
      <div class="result-item">
        <span class="result-item-left">协会名称</span>
        <span class="result-item-right">{{resultData.data[0].assoName}}</span>
      </div>
      <div class="result-item">
        <span class="result-item-left">单位名称</span>
        <span class="result-item-right">{{resultData.data[0].memberName}}</span>
      </div>
      <!-- <div class="submit-btn">
        <el-button type="primary" @click="backGetCertificate('1')">返回</el-button>
      </div> -->
    </div>
    <!-- <CateTemplate v-if="isPersone"></CateTemplate> -->

  </div>
</template>

<script>
// import { modifiedPwd } from '@/api/association'
import CateTemplate from '@/components/common/UserCenter/CateTemplate'
import {formatDate} from '@/components/common/config/formatTime.js'
// import md5 from 'js-md5'
export default {
  name: '',
  components: {
    CateTemplate
  },
  data () {
    return {
      current: null,
      isPersone: false,
      loading: false,
      certificateNumStr: '',
      type: this.$route.params.type,
      currentPage: 1,
      assoUserInfo: JSON.parse(localStorage.getItem('assoUserInfo')),
      titleMsg: '个人信息',
      resultData: JSON.parse(localStorage.getItem('referResultData'))

    }
  },
  methods: {
    formatDate,
    backGetCertificate (type) {
      localStorage.removeItem('referResultData')
      this.$router.push({
        path: '/PersonInfo',
        query: { flag: type }
      })
    },
    getStatusFun () {
      if (this.assoUserInfo.status === 0) {
        return '待审核'
      } else if (this.assoUserInfo.status === 1) {
        return '审核通过 '
      } else if (this.assoUserInfo.status === 2) {
        return '驳回'
      }
    }

  },
  mounted () { // 这里必须是mouted钩子
    // 下拉加载更多监听滚轮
    // window.addEventListener('scroll', this.handleScroll, true) // 监听（绑定）滚轮 滚动事件

  },
  created () {
    if (this.resultData.data[0].projectName === '级位证') {
      this.isPersone = true
    } else {
      this.isPersone = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .personal-certificate{
    width: 815px;
    margin-left: 20px;
    background: #f3f3f3;
    float: right;
    height: 700px;
    padding: 0px 50px;
    border-radius: 10px;
  }
  .result-main{
    width: 500px;
    margin: 0px auto;
    padding-bottom: 20px;
  }
  .result-item{
    overflow: hidden;
    margin-bottom: 10px;
    background: url(/static/images/icon-right.png) right center no-repeat;
  }
  .result-item-left{
    float: left;
    width: 80px;
    padding: 5px 0px;
    font-size: 14px;
  }
  .result-item-right{
    float: left;
    background: #fff;
    width: 300px;
    padding: 5px;
    font-size: 14px;
    border-radius: 5px;
  }
  .certificate-nav{
    float: left;
    width: 100%;
  }
  .person-text-title{
    padding: 30px 0px;
    text-align: center
  }
  .person-text-title span{
    background: url(/static/images/ge-ren.png)0px center no-repeat;
    background-size: 20px 20px;
    padding: 10px 0px 10px 25px;
    font-size: 16px;
  }
  .check-nav{
    padding-top:10px;
    width: 400px;
    margin: 0px auto;
  }
  .check-nav .submit-btn{
    width: 100%;
    text-align: center;
  }
  .check-nav .el-input{
    margin-bottom: 20px;
    text-align: center
  }
  .check-nav .submit-btn .el-button{
    background: #cc0000;
    color: #fff;
    border-color: #cc0000;
    padding: 10px 20px;
  }
  .personal-certificate .seach{
    width: 100%;
    margin-bottom: 5px;
  }
  .personal-certificate .seach .el-input{
    width: 300px;
  }
  .personal-certificate .el-button{
    background: #cc0000;
    color: #fff;
  }
  .right-main{
    width: 815px;
    margin-left: 20px;
    background: #fff;
    float: right;
    height: 616px;
    padding: 0px 50px;
    border-radius: 10px;
  }
  .right-title{
    font-size: 16px;
    text-align: center;
    color:#666;
    margin-top: 50px;
  }
  .right-item{
    border-bottom: 1px solid #eee;
    padding: 15px 0px;
    overflow: hidden;
    color:#666;
    font-size: 14px;
    line-height: 30px;
    background: url(/static/images/icon-right.png) 0px center no-repeat;
  }
  .right-item .user-name{
    float: left;
    background-position: 0px center;
    background-repeat: no-repeat;
    background-size: 25px 27px;
    background-size: 25px 27px;
    padding-left: 30px;
    margin-left: 40px;
    width: 100px;
  }
  .submit-btn{
    width: 100%;
    text-align: center;
    margin-top: 20px;
  }
  .submit-btn .el-button{
    background: #cc0000;
    color: #fff;
    border-color: #cc0000;
    padding: 10px 20px;
  }
  .showPass{
    font-size: 14px;
    border: none;
    background: none;
    outline:none;
    margin-left: 100px;
  }
  input:focus {
    border: none
  }
  .right-item .icon-name{
    background-image: url(/static/images/login-user.png);
  }
  .right-item .icon-pass{
    background-image: url(/static/images/login-pass.png);
  }
  .right-item .icon-user{
    background-image: url(/static/images/icon-tuanti.png);
  }
  .right-item .icon-state{
    background-image: url(/static/images/icon-state.png);
  }
  .right-item .begin-time{
    background-image: url(/static/images/begin-time.png);
  }
  .right-item .end-time{
    background-image: url(/static/images/end-time.png);
  }
  .right-item .name-text{
    float: left;
    margin-left: 100px;
  }
  .right-item .updata{
    float:right;
    padding:0px 10px;
    cursor: pointer;
  }
  .submit{
    padding-top: 50px;
    text-align: center;
  }
  .submit span{
    padding: 10px 50px;
    background: #cc0000;
    border-radius:5px;
    color: #fff;
    cursor: pointer;
  }
  .fixd {
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0px;
    z-index: 99999;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/UserCenter/ReferCertificate.vue